import { render, staticRenderFns } from "./PurchasingInventoryModal.vue?vue&type=template&id=25c47ad2&"
import script from "./PurchasingInventoryModal.vue?vue&type=script&lang=js&"
export * from "./PurchasingInventoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports